import React, { useState, useRef, useEffect } from "react";
import './stepCompetencesEvaluation.css';
import StepCompetencesEvaluationDesc from "../stepCompetencesEvaluationDesc/stepCompetencesEvaluationDesc";
import FormEvaluationAnswerGroupEv from "../formEvaluationAnswerGroup/formEvaluationAnswerGroupEv";

import { Layout, Typography, Progress, Button, Radio, Input, message } from "antd";
const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const StepCompetencesEvaluation = ({ 
    questions, 
    evaluation, 
    dataEvaluationAnswerGroups,
    onAnswerChange,
    onObservationChange,
    saveEvaluationAnswers,
    newCurrentStep
}) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [answers, setAnswers] = useState({});
    const topRef = useRef(null);
    const questionRefs = useRef({});

    const totalSteps = questions.length + 2; // Bienvenida + Final
    const progressPercent = Math.round((currentStep / (totalSteps - 1)) * 100);

    useEffect(() => {
        setCurrentStep(newCurrentStep)
    }, [newCurrentStep]);

    const formatWithLineBreaks = (text) => {
        if (!text) return null;
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    const renderStepContent = () => {
        if (currentStep === 0) {
            return (
                <div style={{ textAlign: "center" }}>
                    <Title level={3}>{evaluation.evl_title.toUpperCase()}</Title>
                    <Title level={4}>
                        {evaluation.evr_evaluator_gender === "F" ? "BIENVENIDA" : "BIENVENIDO"} {evaluation.evr_evaluator_fullname.toUpperCase()}
                    </Title>
                    <Paragraph style={{ width: "100%", textAlign: "justify", fontSize: '16px' }}>
                        {formatWithLineBreaks(evaluation.evl_welcome_message)}
                    </Paragraph>
                    <StepCompetencesEvaluationDesc
                        evr_evaluator={evaluation.evr_evaluator}
                        evr_evaluator_fullname={evaluation.evr_evaluator_fullname}
                        evr_evaluator_job_title={evaluation.evr_evaluator_job_title}
                        evr_evaluated={evaluation.evr_evaluated}
                        evr_evaluated_fullname={evaluation.evr_evaluated_fullname}
                        evr_evaluated_job_title={evaluation.evr_evaluated_job_title}
                        evr_type={evaluation.evr_type}
                    />
                </div>
            );
        }

        if (evaluation.evl_comments_option == 3 || evaluation.evl_comments_option == "3") {
            return <div style={{ marginTop: 20 }}>
                <Text style={{ fontWeight: 500, fontSize: '16px' }} type="secondary">Observaciones</Text>
                <TextArea
                    rows={4}
                    placeholder="Utiliza este espacio para consignar tus observaciones"
                    value={evaluation.evr_observations[0].eob_observation}
                    onChange={(e) => onObservationChange(evaluation.evl_id, null, null, e.target.value)}
                    style={{ marginTop: 10, fontSize: '16px' }}
                />
            </div>
        }
        
        if (currentStep === totalSteps - 1) {
            return (
                <div style={{ textAlign: "center" }}>
                    <Paragraph style={{ fontSize: '16px' }}>{evaluation.evl_final_message}</Paragraph>
                    <Paragraph style={{ fontSize: '16px' }}>No olvides dar click en el botón "Finalizar" para cerrar la evaluación</Paragraph>
                </div>
            );
        }

        const block = evaluation.evr_questions[currentStep - 1]; // Restamos 1 porque el paso 0 es la bienvenida
        let currentObservationBlock = evaluation.evr_observations.find(
                o => o.eob_evl_id === evaluation.evl_id &&
                    o.eob_cmp_id === block.cmp_id &&
                    o.eob_dsc_id === null
            )?.eob_observation || ""
        return (
            <div>
                <Title level={4}>{block.title}</Title>
                {
                    block.questions.map((q, idx) => {
                        const evaluationAnswerGroup = dataEvaluationAnswerGroups.find(
                            group => group.eag_id === q.ean_eag_id // o 'group.eag_id' según cómo venga la data
                        );
                        
                        return (
                            <div 
                                ref={el => questionRefs.current[q.ean_dsc_id] = el}
                                key={idx} 
                                style={{ 
                                    marginBottom: 24, 
                                    padding: 16, 
                                    borderRadius: 10,
                            }}
                            >
                                <Text strong style={{ fontSize: '16px' }}>{`Pregunta ${idx + 1}`}</Text>

                                <div style={{ marginTop: 10 }}>
                                    <FormEvaluationAnswerGroupEv
                                        key={q.ean_dsc_id}
                                        source={block.source}
                                        evaluationAnswerGroup={evaluationAnswerGroup}
                                        question={q}
                                        evlCommentsOption={evaluation.evl_comments_option}
                                        onChange={(answer) => onAnswerChange(block.dimension, q.ean_dsc_id, answer)}
                                        handleObservationChange={(obsText) =>
                                            onObservationChange(evaluation.evl_id, q.ean_cmp_id, q.ean_dsc_id, obsText)
                                        }
                                        currentObservation={
                                            evaluation.evr_observations.find(
                                                o => o.eob_evl_id === evaluation.evl_id &&
                                                    o.eob_cmp_id === q.ean_cmp_id &&
                                                    o.eob_dsc_id === q.ean_dsc_id
                                            )?.eob_observation || ""
                                        }
                                    />
                                </div>
                            </div>
                        )
                    })
                }
                {
                    block.source !== "evaluation" && (evaluation.evl_comments_option == 2 || evaluation.evl_comments_option == "2") && <div style={{ marginTop: 20 }}>
                        <Text style={{ fontWeight: 500 }} type="secondary">Observaciones</Text>
                        <TextArea
                            rows={4}
                            placeholder="Utiliza este espacio para consignar tus observaciones"
                            value={currentObservationBlock}
                            onChange={(e) => onObservationChange(evaluation.evl_id, block.cmp_id, null, e.target.value)}
                            style={{ marginTop: 10, fontSize: '16px' }}
                        />
                    </div>
                }
            </div>
        );
    };

    const handleNext = () => {
        if (!isCurrentStepValid()) {
            message.warning("Por favor responde todas las preguntas antes de continuar.");
            return;
        }

        if (currentStep < totalSteps - 1) {
            setCurrentStep(currentStep + 1);
            scrollToTop();
            saveEvaluationAnswers(false, currentStep+1);
        }
        else {
            saveEvaluationAnswers(true, currentStep+1);
        }
    };

    const handlePrevious = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
            scrollToTop();
        }
    };

    const scrollToTop = () => {
        topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    // const isCurrentStepValid = () => {
    //     if (currentStep === 0 || currentStep === totalSteps - 1) return true;

    //     const block = evaluation.evr_questions[currentStep - 1];
    //     if (!block || !block.questions) return false;

    //     return block.questions.every(q => {
    //         const hasAnswer = q.ean_answer !== null && q.ean_answer !== undefined && q.ean_answer !== "";
    //         const hasText = q.ean_answer_text !== null && q.ean_answer_text !== undefined && q.ean_answer_text !== "";
    //         return hasAnswer || hasText;
    //     });

    //     // return true;
    // };

    const isCurrentStepValid = () => {
        if (currentStep === 0 || currentStep === totalSteps - 1) return true;

        const block = evaluation.evr_questions[currentStep - 1];
        if (!block || !block.questions) return false;

        for (let q of block.questions) {
            const hasAnswer = q.ean_answer !== null && q.ean_answer !== undefined && q.ean_answer !== "";
            const hasText = q.ean_answer_text !== null && q.ean_answer_text !== undefined && q.ean_answer_text !== "";

            if (!hasAnswer && !hasText) {
                const ref = questionRefs.current[q.ean_dsc_id];
                if (ref && ref.scrollIntoView) {
                    ref.scrollIntoView({ behavior: "smooth", block: "center" });

                    ref.classList.add("highlight-question");

                    setTimeout(() => {
                        ref.classList.remove("highlight-question");
                    }, 3000);
                }
                return false;
            }
        }

        return true;
    };

    const currentBlock = questions[currentStep - 1];
    const allAnswered = currentStep === 0 || currentStep === totalSteps - 1 ||
        (currentBlock?.questions?.every(q => answers[q.ean_question]?.value));

    return (
        <Layout 
        
            ref={topRef} 
            style={{
                background: "#fff",
                width: "100%",
                maxWidth: "850px", // o lo que prefieras
                padding: "64px 24px 24px", // 👈 deja espacio arriba para la burbuja
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                marginTop: 24, // pequeño margen por si quieres separación
            }}
        >
            <div style={{
                position: "absolute",
                top: 16,
                right: 24,
                backgroundColor: "#1890ff",
                color: "#fff",
                width: 50,
                height: 50,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "18px",
                boxShadow: "0 0 8px rgba(0,0,0,0.2)"
            }}>
                {progressPercent}%
            </div>

            <Progress percent={progressPercent} showInfo={false} />

            <div style={{ marginTop: 24 }}>
                {renderStepContent()}
            </div>

            <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Button onClick={handlePrevious} disabled={currentStep === 0}>
                    Anterior
                </Button>
                <Button type="primary" onClick={handleNext} >
                    {currentStep === totalSteps - 1 ? "Finalizar" : "Siguiente"}
                </Button>
            </div>
        </Layout>        
    );
};

export default StepCompetencesEvaluation;
